import { render, staticRenderFns } from "./VesselAccessControl.vue?vue&type=template&id=4bb1d260&scoped=true&"
import script from "./VesselAccessControl.vue?vue&type=script&lang=ts&"
export * from "./VesselAccessControl.vue?vue&type=script&lang=ts&"
import style0 from "./VesselAccessControl.vue?vue&type=style&index=0&id=4bb1d260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1d260",
  null
  
)

export default component.exports